import { OAuthConnectPage } from "../oauth-connect-page"

export function ConnectQuickbooksPage() {
  return <OAuthConnectPage provider="quickbooks" displayName="Quickbooks" returnPath="/setup/connect" />
}
